import { createSelector } from "reselect"

import { OwnProps as ContextMenuModalProps } from "./components/ContextMenuModalContent"
import { ICardView } from "./index"
import { IButton } from "../common/contextmenu"

const getActions = (
    _state: ICardView,
    _props: ContextMenuModalProps,
): IButton[] => _props.item.contextMenu?.actions || []

export const getPrimaryActions = createSelector([getActions], (actions) =>
    actions.filter((b: IButton) => !b.inOptionalMenu),
)

export const getSecondaryActions = createSelector([getActions], (actions) =>
    actions.filter((b: IButton) => b.inOptionalMenu),
)
